export class ImageSnippet {
  pending: boolean = false;

  progress: number = 0;

  constructor(public src: string | ArrayBuffer) {}
}
